import { useRef } from "react";
import styled from "styled-components";
import { Tooltip } from "@mantine/core";

import { CopyButton } from "@components";

import { CopyInputGroup } from "./RuleShareUtils";

export const CopyIconWrapper = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  margin-left: 8px;
  margin-right: 16px;
`;

export function RuleSharePreview({
  input,
  style,
  leftElement,
}: {
  input: string;
  style?: React.CSSProperties;
  leftElement?: JSX.Element;
}) {
  const inputRef = useRef(null);
  return (
    <CopyInputGroup
      fill
      inputRef={inputRef}
      value={input}
      onChange={() => {}}
      onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.select()}
      style={{
        boxShadow: "none",
        backgroundColor: "var(--light-gray2)",
        textOverflow: "ellipsis",
        ...style,
      }}
      readOnly
      rightElement={
        <CopyIconWrapper>
          <Tooltip label="Copy" withArrow withinPortal position="left">
            <div>
              <CopyButton getTarget={() => inputRef.current} />
            </div>
          </Tooltip>
        </CopyIconWrapper>
      }
      leftElement={leftElement}
    />
  );
}
